import {
  removeNullAttributes,
  queryStringFromObject,
  authHeader,
  handleResponse,
  handleNoContentResponse,
} from "../_helpers";

const BASE_URL = process.env.REACT_APP_BASE_URL;

function getVersionList(queryParams) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  const { sortOrder, sortBy } = { ...queryParams };
  delete queryParams.sortOrder;
  delete queryParams.sortBy;

  const sortQuery =
    sortOrder && sortBy
      ? `&sort=${
          sortBy === "uploadedDate" ? "uploadedDateInMillis" : sortBy
        }:${sortOrder}`
      : "";

  const queryObject = removeNullAttributes(queryParams);
  const query = queryStringFromObject(queryObject);

  const endPoint = `/api/admin/v1/version-files/fuses?${query}${sortQuery}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function uploadVersion(formData) {
  const requestOptions = {
    method: "POST",
    headers: {
      // "Content-Type": "multipart/form-data",
      ...authHeader(),
    },
    body: formData,
  };

  const endPoint = `/api/admin/v1/version-files/fuses`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleNoContentResponse)
    .then((data) => {
      return data;
    });
}

export const versionListService = {
  getVersionList,
  uploadVersion,
};
